<header role="banner">
  <app-header-bar></app-header-bar>
</header>
<main role="main">
  <router-outlet></router-outlet>
</main>
